// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"battery-add"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 4H9V1.5H15V4H20V22.5H4V4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 4H9V1.5H15V4H20V22.5H4V4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 10.5V13.5M12 13.5V16.5M12 13.5H9M12 13.5H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BatteryAddIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'battery-add',
    ref,
    icon: element,
  },
));

BatteryAddIcon.displayName = 'BatteryAddIcon';

export default BatteryAddIcon;
